export interface ExerciseOption {
  id: string;
  label: string;
  hint: string;
}

export const EXERCISES: ExerciseOption[] = [
  { id: 'squat',              label: '深蹲',     hint: '下肢对称 · 蹲深' },
  { id: 'plank',              label: '平板支撑', hint: '核心稳定 · 脊柱' },
  { id: 'single_leg_stretch', label: '单腿伸展', hint: '平衡 · 髋部' },
];

const LABEL_MAP = Object.fromEntries(EXERCISES.map((e) => [e.id, e.label]));

export function exerciseLabel(id: string): string {
  if (id === 'none') return '检测中';
  if (id === 'standing') return '站立';
  return LABEL_MAP[id] ?? id;
}
